export const personalInfo = {
    firstName: "Luca",
    lastName: "Meli",
    location: "Deutschland, Köln",
    email: "info@lmeli.com",
    socialLinks: {
        GitHub: "https://github.com/scorpio-99",
        LinkedIn: "https://www.linkedin.com/in/meli-luca",
    },
};
